// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import URL from '../constants/urls'
import ExtendFormNew from '../pages/ExtendFeatureForm/ExtendFormNew'
import ExtendResponse from '../pages/ExtendFeatureForm/ExtendResponse'
import Main from '../pages/main/Main'
// import Ticket from '../pages/main/Ticket'
// import SearchTicket from '../pages/searchTicket/SearchTicket'
import Transient from '../pages/transientForm/TransientForm'
import PaymentResponse from '../pages/paymentReposnse/PaymentResponse'
import NotFound from '../components/global/NotFound'
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword'
import Login from '../components/global/login/login'
import Singup from '../components/global/login/singup'
import ListItemForMenu from '../components/global/login/listItemForMenu'
import SendEmailResetPassword from '../components/global/SendEmailResetPassword'
import VehicleList from '../pages/vehicle/vehicleList'
import { toast, ToastContainer } from 'react-toastify'
import Profile from '../pages/profile/Profile'
import PaymentList from '../components/global/Payment/PaymentList'
import PaymentGatwayDc from '../components/global/Payment/PaymentGatwayDc'
import Receipts from '../components/global/Receipts/Receipts'
import ReceiptsDetails from '../components/global/Receipts/ReceiptsDetails'
import ReceiptList from '../pages/Receipt/ReceiptList'
import VehicleForm from '../pages/vehicle/VehicleForm'
import VehicleEdit from '../pages/vehicle/VehicleEdit'
import AboutUs from '../components/global/aboutUs/AboutUs'
import ServicePage from '../components/global/aboutUs/ServicePage'
import { getPartnerDetails, getPartnerLogo, getPartnerTagline, getRootDomain, isIPAddress, isPermissionExist, sortPortalPermissionByKey } from '../utils/helper'
import ScanQr from '../pages/scanQr/ScanQr'
import useNetwork from '../Hooks/NetworkDetector'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/globalConstants'
import { getPartnerDetailsBySLug } from '../redux/actions/userDetails'
import ScanAutoValidationQr from '../components/global/ScanAutoValidationQr'
// import Base from '../components/global/Base'
import ApplePayDataCap from '../pages/ApplePayDataCap/ApplePayDataCap'
import 'react-toastify/dist/ReactToastify.css'
import { errorMessage } from '../constants/errorMessage'
import { Circles } from 'react-loader-spinner'
import CONSTANTS from '../redux/constants'
import { addEventLog } from '../redux/actions/EventsLog'
import { getConfigDetails } from '../services/config'
import MobileWalletButtons from '../components/walletButtons/MobileWalletButtons'
import Loader from '../global/Loader'
import Hotel from '../pages/hotelFlow/Hotel'
import SupportButton from '../components/global/Support/SupportButton'
import DownloadApp from '../components/global/DownloadApp'
import { LayoutWrapper } from './LayoutWrapper'

// import './YourComponent.css' // Create this CSS file for styling

function PublicRoutes(props) {
    const { dispatch } = props
    const [faviconPath, setFaviconPath] = useState('')
    const [partnerDetails, setPartnerDetails] = useState(EMPTY_OBJECT)
    const [title, setTitle] = useState('')
    let user = window.location.toString().split('/')[3]
    const encodedString = window.location.toString().split('/')[5]
    const isOnline = useNetwork()
    const [partnerByAPI, setPartnerByAPI] = useState(0)
    const [isDataUpdate, setDataUpdate] = useState(false)
    const [refLoad, setRefLoad] = useState(false)
    const [isFetchingPartner, setIsFetchingPartner] = useState(true)
    const [displayBanner, setDisplayBanner] = useState(false)
    const [isDisplayBanner, setIsDisplayBanner] = useState(true)

    const domain = getRootDomain()

    useEffect(() => {
        // Listen for changes in localStorage
        window.addEventListener('storage', (event) => {
            if (event.key === 'partnerData' || event.key === 'faclityData') {
                // Store the updated data or flag in session storage to detect tab switches
                sessionStorage.setItem('dataUpdated', 'true')
            }
        })

        // const decodeBase64 = (encodedString) => {
        //     if (window.location.toString().split('/')[4] != 'h') {
        //         const decodedString = atob(encodedString)
        //         return JSON.parse(decodedString)
        //     }
        // }
        const decodeBase64 = (encodedString) => {
            if (window.location.toString().split('/')[4] !== 'h') {
                try {
                // Ensure proper padding (Base64 requires length % 4 === 0)
                let str = encodedString.trim()
                while (str.length % 4 !== 0) {
                    str += '='
                }

                const decodedString = atob(str)
                return JSON.parse(decodedString)
                } catch (e) {
                console.error('Invalid Base64 input:', encodedString, e)
                return null
                }
            }
        }

        // Check for updates when the tab becomes active
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && sessionStorage.getItem('dataUpdated') === 'true') {
                const updatedData = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : null
                const updatedFacilityData = localStorage.getItem('faclityData') ? JSON.parse(localStorage.getItem('faclityData')) : null
                const currentFacility = decodeBase64(encodedString)
                console.log(currentFacility)
                if (((updatedFacilityData?.facility?.id != currentFacility?.facility_id) || (updatedData?.slug != '' && updatedData?.slug != null && user != updatedData?.slug) || (updatedData?.partner_slug != '' && updatedData?.partner_slug != null && user != updatedData?.partner_slug)) || !updatedData || !updatedFacilityData) {
                    setDataUpdate(true)
                } else {
                    setDataUpdate(false)
                }
                // Clear the flag after showing the message
                sessionStorage.removeItem('dataUpdated')
            }
        })
        let partnerDate = localStorage.getItem('partnerData') != 'undefined' ? JSON.parse(localStorage.getItem('partnerData')) : {}

        if (user != partnerDate?.slug && user != partnerDate?.partner_slug) {
            handleLogout()
        }
    }, [EMPTY_ARRAY, user])

    const handleLogout = () => {
        localStorage.removeItem('userData')
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('masquerade')
        if (getPartnerDetails()) {
            sessionStorage.setItem('partnerSecret', getConfigDetails()?.CLIENT_SECRET)
            sessionStorage.setItem('partnerData', JSON.stringify(getPartnerDetails()))
        }
        localStorage.removeItem('partnerSecret')
        sessionStorage.removeItem('partnerSecret')
        localStorage.removeItem('partnerData')
        sessionStorage.removeItem('partnerData')
        // localStorage.clear()
    }

    useEffect(() => {
        if (user != 'mgooglepay' && !user.includes('mgooglepay')) {
            localStorage.removeItem('partnerData')
            if (window.location.toString().split('/')[4] == 'h') {
                user = `${user}?qrCode=${window.location.toString().split('/')[5]}`
            }

            if (domain && (domain.includes('parkpayride') || domain.includes('park2visit'))) {
                user = `${user}?domain=${domain}`
            }


            dispatch(getPartnerDetailsBySLug(user)).then((res) => {
                if (res?.data?.email) {
                    setPartnerSlugData(res)
                } else {
                    if (partnerByAPI < 1) {
                        setPartnerByAPI(partnerByAPI + 1)
                        dispatch(getPartnerDetailsBySLug(user)).then((res) => {
                            setIsFetchingPartner(false)
                            if (res?.data?.email) {
                                setPartnerSlugData(res)
                            } else {
                                setPartnerDetails(res?.data)
                                localStorage.removeItem('partnerData')
                            }

                        }).catch((err) => {
                            setIsFetchingPartner(false)
                            let errObject = {
                                payload: user,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getPartnerDetailsBySLug-PublicRoutes.js-89`))
                        })
                    } else {
                        setPartnerDetails(res?.data)
                        localStorage.removeItem('partnerData')
                    }

                }

            }).catch((err) => {
                setIsFetchingPartner(false)
                setPartnerDetails(EMPTY_OBJECT)
                localStorage.removeItem('partnerData')
                let errObject = {
                    payload: user,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getPartnerDetailsBySLug-PublicRoutes.js-83`))

            })
        } else {
            setIsFetchingPartner(false)
        }
    }, [EMPTY_ARRAY])
    useEffect(() => {
        const updateFavicon = () => {
            const favicon = document.querySelector('link[rel="icon"]')
            favicon.href = faviconPath
        }

        const updateTitle = () => {
            document.title = title
        }

        updateFavicon()
        updateTitle()
    }, [faviconPath, title])


    const notify = (type, message) => {
        if (type === 'error') {
            toast.error(message, {
                position: toast.POSITION.TOP_RIGHT
            })
            toast.clearWaitingQueue()
        } else if (type === 'success') {
            toast.success(message, {
                position: toast.POSITION.TOP_RIGHT
            })
            toast.clearWaitingQueue()
        }
    }

    const DisplayToast = (text, title) => {
        return <div className='network-warning'>
            <span className='text-center fw-bold d-block'>{title}</span>
            <span className='text-center'>{text}</span>
        </div>
    }

    const setPartnerSlugData = (res) => {
        setPartnerDetails(res?.data)
        localStorage.removeItem('partnerData')
        localStorage.setItem('partnerData', JSON.stringify(res?.data))
        const partnerData = res?.data
        const color = partnerData?.brand_setting?.color
        const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
        const newFaviconPath = partnerData?.brand_setting?.faviconurl ? partnerData?.brand_setting?.faviconurl : getPartnerLogo(user)
        setFaviconPath(newFaviconPath)
        const newTitle = partnerData?.company_name ? partnerData?.company_name : getPartnerTagline(user)
        setTitle(newTitle)
        if (color) {
            document.documentElement.style.setProperty('--bs-primary', color)
            document.documentElement.style.setProperty('base-color', color)
            document.documentElement.style.setProperty('primary', color)
            document.documentElement.style.setProperty('textcolor', color)
            document.documentElement.style.setProperty('--bs-btn-bg', color)
            document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
            document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
            document.documentElement.style.setProperty('--bs-list-group-active-color', color)
            document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
        }

        const hasAccess = isPermissionExist(sortPortalPermissionByKey(partnerData, 'Restricted Permissions'), 'Display Download Banner')
        setDisplayBanner(hasAccess)
    }
    const refreshPage = () => {
        setRefLoad(true)
        window.location.reload()
    }

    return (
        <div>
            <BrowserRouter forceRefresh className="my-3 mb-5">
                {!isOnline ?
                    DisplayToast('Please check the Internet Connection!', 'Warning') : null}
                {(partnerDetails?.email && partnerDetails?.email != '') ? <Routes>
                    <Route element={<LayoutWrapper />}>
                        {/* {loggedInUserData()?.access_token ? <Route
                        path={URL.HOME}
                        element={
                            <ListItemForMenu partnerDetails={partnerDetails} />
                        }
                    /> : <Route
                        path={URL.HOME}
                        element={
                            <Transient notify={notify} partnerDetails={partnerDetails} />
                        }
                    />
                    } */}
                        <Route
                            path={URL.HOME}
                            element={
                                <Transient notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.INDEX}
                            element={
                                <Main notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.HOME2}
                            element={
                                <Transient notify={notify} partnerDetails={partnerDetails} />
                            }
                        />

                        <Route
                            path={URL.HOME3}
                            element={
                                <Transient notify={notify} partnerDetails={partnerDetails} />
                            }
                        />

                        <Route
                            path={URL.HOTEL_URL}
                            element={
                                <Hotel notify={notify} partnerDetails={partnerDetails} />
                            }
                        />

                        {/* login routes  */}
                        <Route
                            path={URL.LOGIN_INDEX}
                            element={<Login notify={notify} partnerDetails={partnerDetails} />}
                        />
                        <Route
                            path={URL.SING_UP}
                            element={<Singup notify={notify} partnerDetails={partnerDetails} />}
                        />
                        <Route
                            path={URL.LIST_MENU}
                            element={<ListItemForMenu notify={notify} partnerDetails={partnerDetails} />}
                        />


                        <Route
                            path={URL?.VEHICLE_LIST}
                            element={<VehicleList notify={notify} partnerDetails={partnerDetails} />}
                        />

                        <Route
                            path={URL?.VEHICLE_ADD}
                            element={<VehicleForm notify={notify} />}
                        />

                        <Route
                            path={URL?.VEHICLE_EDIT}
                            element={<VehicleEdit notify={notify} />}
                        />
                        {/* login routes end  */}
                        <Route
                            path={URL.USER_PROFILE}
                            element={
                                <Profile notify={notify} />
                            }
                        />
                        <Route
                            path={URL.EXTEND_SUCCESS}
                            element={
                                <ExtendResponse notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.CONFIRMATION_SCREEN}
                            element={
                                <PaymentResponse notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.DETAILS}
                            element={
                                <PaymentResponse notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.SCAN_TOKEN_VALIDATE}
                            element={
                                <ScanAutoValidationQr notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                        <Route
                            path={URL.TICKET_EXTEND}
                            element={
                                <ExtendFormNew notify={notify} partnerDetails={partnerDetails} />
                            } />
                        <Route
                            path={URL.TICKET}
                            element={
                                <NotFound />
                            }
                        />
                        <Route
                            path={URL.SEARCH}
                            element={
                                <NotFound />
                            }
                        />
                        <Route
                            path={URL.INVALID}
                            element={
                                <NotFound />
                            }
                        />


                        <Route
                            path={URL.RECEIPT}
                            element={<ReceiptList notify={notify} />}
                        />

                        <Route
                            path={URL.FORFOT_PASSWORD}
                            element={
                                <ForgotPassword notify={notify} />
                            }
                        />
                        <Route
                            path={URL.SEND_EMAIL_RESET_PASSWORD}
                            element={
                                <SendEmailResetPassword notify={notify} />
                            }
                        />
                        <Route
                            path={URL?.PAYMENT_LIST}
                            element={<PaymentList notify={notify} />}
                        />
                        <Route
                            path={URL?.GET_RECEIPTS}
                            element={<Receipts notify={notify} />}
                        />
                        <Route
                            path={URL?.RECEIPT_DETAILLS}
                            element={<ReceiptsDetails notify={notify} />}
                        />
                        <Route
                            path={URL?.ADD_PAYMENT}
                            element={<PaymentGatwayDc notify={notify} />}
                        />

                        <Route
                            path={URL?.ABOUT_US}
                            element={<AboutUs partnerDetails={partnerDetails} />}
                        />
                        <Route
                            path={URL?.SERVICE_PAGE}
                            element={<ServicePage />}
                        />
                        <Route
                            path={URL?.SCAN_FACILITY_QR}
                            element={<ScanQr notify={notify} />}
                        />
                        <Route
                            path={URL?.FACILITY_QR}
                            element={<ScanQr notify={notify} />}
                        />

                        {/* apple PAY */}
                        <Route
                            path={URL?.APPLEPAY}
                            element={<ApplePayDataCap notify={notify} />}
                        />
                        {/* {aPPLE PAY END} */}
                    </Route>
                </Routes> : <Routes>
                    <Route element={<LayoutWrapper />}>
                        <Route
                            path={URL?.INVALID}
                            element={
                                isFetchingPartner ? <Loader />
                                    : <NotFound />
                            }
                        />
                        <Route
                            path={URL?.SCAN_FACILITY_QR}
                            element={<ScanQr notify={notify} />}
                        />
                        <Route
                            path={URL?.FACILITY_QR}
                            element={<ScanQr notify={notify} />}
                        />
                        <Route
                            path={URL.HOME}
                            element={
                                <Transient notify={notify} partnerDetails={partnerDetails} />
                            }
                        />
                    </Route>
                </Routes>}

                <Routes>
                    <Route
                        path={URL?.M_GOOGLE_PAY}
                        element={
                            <MobileWalletButtons notify={notify} partnerDetails={partnerDetails} />
                        }
                    />

                </Routes>
            </BrowserRouter>
            <ToastContainer limit={1} />
            {isDataUpdate && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <p>{errorMessage?.awayMessage}</p>
                        <div className="d-flex gap-2 justify-content-end">
                            <button
                                disabled={refLoad}
                                type="button"
                                className="btn bg-primary text-white d-flex align-items-center"
                                onClick={() => refreshPage()}
                            >
                                {refLoad ? <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="#ffffff"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /> : ''}
                                <span className={`${refLoad ? 'ms-2' : ''}`}>Refresh</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {displayBanner && (partnerDetails && partnerDetails?.app_store_urls && partnerDetails?.app_store_urls?.length > 0) ? <DownloadApp
                appUrls={partnerDetails?.app_store_urls}
                setIsDisplayBanner={setIsDisplayBanner}
            /> : null}

            {/* Display Support Mail for ParkPayride and Park2Visit Temporary Until Jira Widget is Ready */}
            {window?.location?.toString().includes('parkpayride') || window?.location?.toString().includes('park2visit') || window?.location?.toString().includes('localhost') || isIPAddress(window?.location?.hostname) ?
                <SupportButton
                    partnerDetails={partnerDetails}
                    isAppStore={displayBanner && (partnerDetails && partnerDetails?.app_store_urls && partnerDetails?.app_store_urls?.length > 0) && isDisplayBanner}
                />
                : null}
            {/* Display Support Mail for ParkPayride and Park2Visit Temporary Until Jira Widget is Ready */}
        </div>
    )
}

PublicRoutes.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    cards: PropTypes.array,
    vehicleDataList: PropTypes.array,
    isFetchingPartner: PropTypes.bool,
}

PublicRoutes.defaulProps = {
    dispatch: noop,
    loader: true,
    isFetching: true,
    notify: noop,
    cards: EMPTY_ARRAY,
    vehicleDataList: EMPTY_ARRAY,
    isFetchingPartner: true,

}

function mapStateToProps({ transientReducer, PaymentReducer, VehilceReducer, userDetailsReducer }) {
    const { data } = VehilceReducer

    return {
        loader: transientReducer?.loader,
        isFetching: transientReducer?.loader,
        cards: PaymentReducer?.data?.data,
        vehicleDataList: data?.data,
        isFetchingPartner: userDetailsReducer?.isFetching
    }
}

export default connect(mapStateToProps)(PublicRoutes)